import React from 'react';
import * as ActionTypes from '../../constants/ActionTypes';
import { handleActions } from 'redux-actions';

const initialState = { uploading: false, error: false };

const assetUploadReducer = handleActions(
    {
        [ActionTypes.IMAGES_UPLOAD_REQUEST]: (state, action) => {
            return { ...state, uploading: true, error: false, [action.target]: action.image };
        },
        [ActionTypes.IMAGES_UPLOAD_SUCCESS]: (state, action) => {
            return { ...state, uploading: false, error: false, message: action.message };
        },
        [ActionTypes.IMAGES_UPLOAD_FAILURE]: (state, action) => {
            return { ...state, uploading: false, error: true, message: action.error };
        }
    },
    initialState
);

export default assetUploadReducer;



// WEBPACK FOOTER //
// ./src/reducers/images/assetUpload.js